import React from 'react'

const Icon: React.FC = () => {
  return (
    <svg
      width="19.5"
      height="9.5"
      viewBox="0 0 23 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.4375 1.07422L11.2998 10.9365L21.1621 1.07422"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Icon
